// @flow

import * as React from 'react';
import Box from 'sail/Box';
import {Subheading} from 'sail/Text';
import './BeforeAfterTable.scss';
import {defineMessages, FormattedMessage} from 'react-intl';

const messages = defineMessages({
  before: {
    id: 'docsApp.components.beforeAfterTable.before',
    description: 'Label for what the code looked like before',
    defaultMessage: 'Before',
  },
  after: {
    id: 'docsApp.components.beforeAfterTable.after',
    description: 'Label for what the code looks like after',
    defaultMessage: 'After',
  },
});

type BeforeAfterTableProps = {|
  beforeNodes: Array<React.Node>,
  afterNodes: Array<React.Node>,
|};

// The before or after tag could have multiple children which is why we do this.
const toFragment = (node, key) => (
  <React.Fragment key={key}>{node}</React.Fragment>
);

export const BeforeAfterTable = ({
  beforeNodes,
  afterNodes,
}: BeforeAfterTableProps) => {
  const before = beforeNodes.map(toFragment);
  const after = afterNodes.map(toFragment);
  return (
    <Box className="BeforeAfterTable">
      <Box padding={{bottom: 4}} className="BeforeAfterTable-header">
        <Box className="BeforeAfterTable-before">
          <Subheading>
            <FormattedMessage {...messages.before} />
          </Subheading>
        </Box>
        <Box>
          <Subheading>
            <FormattedMessage {...messages.after} />
          </Subheading>
        </Box>
      </Box>
      <Box className="BeforeAfterTable-container">
        <Box className="BeforeAfterTable-diff BeforeAfterTable-before">
          {before}
        </Box>
        <Box className="BeforeAfterTable-diff">{after}</Box>
      </Box>
    </Box>
  );
};
